import { __assign, __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from '@mui/material/styles';
import MoaStyledComponent from '../../Style/MoaStyled';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { Typography } from "../../";
var BootstrapTooltip = styled(function (_a) {
    var className = _a.className, props = __rest(_a, ["className"]);
    return (_jsx(Tooltip, __assign({}, props, { arrow: true, classes: { popper: className } })));
})(function (_a) {
    var _b;
    var theme = _a.theme, arrowBorder = _a.arrowBorder;
    return (_b = {},
        _b["& .".concat(tooltipClasses.arrow)] = {
            color: theme.palette.common.white,
            width: "1rem",
            "&::before": {
                border: arrowBorder ? "0.5px solid rgba(0, 0, 0, .1)" : undefined,
            }
        },
        _b["& .".concat(tooltipClasses.tooltip)] = {
            padding: "0.625rem 0.625rem",
            gap: '0.625rem',
            borderRadius: '0.25rem',
            boxSizing: 'border-box',
            backgroundColor: 'var(--color-bg, #ffffff)',
            display: 'flex',
            boxShadow: 'var(--elevation-200-canvas, 0px 0px .5px rgba(0, 0, 0, .18), 0px 3px 8px rgba(0, 0, 0, .1), 0px 1px 3px rgba(0, 0, 0, .1))',
        },
        _b);
});
var StyledComponent = styled(function (props) {
    var id = props.id, children = props.children, title = props.title, placement = props.placement, arrowBorder = props.arrowBorder;
    return (_jsx(BootstrapTooltip, { title: typeof title === 'string' ? _jsx(Typography, { children: title }) : title || undefined, placement: placement || 'bottom', open: props === null || props === void 0 ? void 0 : props.open, arrowBorder: arrowBorder, children: _jsx("div", { id: id, children: children }) }));
})(function () { return ({}); });
var ThemedComponent = function (props) { return (_jsx(MoaStyledComponent, { children: _jsx(StyledComponent, __assign({}, props)) })); };
export default ThemedComponent;
